import React from 'react';

const NoBookmarks = () => (
  <div className='noBookmarks'>
    <div id='house' />
    <span className='headline'>Save homes on&nbsp;‘Explore’</span>
    <span className='explainerText'>Save homes you like,<br />they will show up here!</span>
    <span className='arrow' />
  </div>
);

NoBookmarks.displayName = 'NoBookmarks';

export default NoBookmarks;
